import React from 'react'

const Main = () => {
  return (
    <section className='user-main-container'>
        <h2 className="main-description">Books you just bought</h2>
    </section>
  )
}

export default Main